import { render } from "./AboutPage.vue?vue&type=template&id=cd9388fc&scoped=true"
const script = {}

import "./AboutPage.vue?vue&type=style&index=0&id=cd9388fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd9388fc"]])

export default __exports__